var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-25 -25 122.31 116.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.08,3.86A34.09,34.09,0,1,0,71.17,38,34.09,34.09,0,0,0,37.08,3.86ZM59.82,42c0,.33,0,.67-.09,1-.23,1.89-.38,3.8-.73,5.67a5.53,5.53,0,0,1-4.66,4.42c-1.79.2-3.59.37-5.39.44-3.05.12-6.1.2-9.14.21a187.53,187.53,0,0,1-19.26-.54,5.73,5.73,0,0,1-5.43-4.71,37.19,37.19,0,0,1-.66-5.36c-.13-2.57-.12-5.15-.1-7.73a37.07,37.07,0,0,1,.78-8.2,5.66,5.66,0,0,1,4.67-4.46c1.78-.21,3.57-.37,5.35-.45q4.53-.18,9.06-.2a187.12,187.12,0,0,1,19.38.54,5.81,5.81,0,0,1,5.47,4.73c.28,1.38.41,2.78.58,4.17.09.73.11,1.47.17,2.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.23,45l14.44-7.49L31.23,30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/YOUTUBE.018c873f769769dcf6392275f8abfb42.svg";
export { ForwardRef as ReactComponent };